import Page from 'client/components/aria/Page/Page';
import styles from './PlatformNoticesPage.module.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import { useEffect } from 'react';
import { Breadcrumbs } from 'client/components/GDS/Breadcrumbs/Breadcrumbs';
import { HOME_PAGE } from 'client/utils/routes/routeConstants';
import { useSelector } from 'react-redux';
import { selectPlatformNoticesLastUpdated } from 'client/store/systemMessageSlice/systemMessageSlice';
import moment from 'moment';
import Table from 'client/components/aria/Table';
import { Cell, Column, Row, TableBody, TableHeader } from 'react-stately';
import PlatformNoticeStatus from './PlatformNoticeStatus';
import { usePlatformNotices } from './usePlatformNotices';
import { logWithPrefix } from 'client/utils/logging';

const log = logWithPrefix('PlatformNotices');

const formatDate = (date, fallback, format) => {
    if (!date) {
        return fallback;
    }

    return moment(date).format(format);
};

const PlatformNoticesPage = () => {
    const intl = useIntl();
    const noticesToShow = usePlatformNotices();
    const lastUpdated = useSelector(selectPlatformNoticesLastUpdated);

    useEffect(() => {
        log('User visited platform notices page');
    }, []);

    const breadcrumbsData = [
        { name: intl.formatMessage({ id: 'navbar.link.home' }), link: HOME_PAGE },
        { name: intl.formatMessage({ id: 'navbar.link.platformNotices' }), ariaCurrent: 'page' }
    ];

    return (
        <Page title={intl.formatMessage({ id: 'platformNoticesPage.title' })} data-testid="platformNoticesPage" className={styles.platformNotices}>
            <div className='govuk-!-margin-bottom-4' data-testid="platformNoticesPage.breadcrumbs">
                <Breadcrumbs items={breadcrumbsData} />
            </div>

            <div className="govuk-grid-row">
                <div className="govuk-grid-column-full">
                    <h1 data-testid="platformNoticesPage.title" className='govuk-heading-xl govuk-!-margin-bottom-6'>{intl.formatMessage({ id: 'platformNoticesPage.title' })}</h1>
                </div>
            </div>
            <div className="govuk-grid-row govuk-!-margin-bottom-6">
                <div className="govuk-grid-column-full">

                    <p className={styles.lastUpdated} data-testid="platformNoticesPage.lastUpdated">
                        {intl.formatMessage({ id: 'platformNoticesPage.lastUpdated' }, { lastUpdated: formatDate(lastUpdated, 'N/A', 'DD MMMM YYYY') })}
                    </p>

                </div>
            </div>
            <Table className={styles.platformNoticesTable} aria-label={intl.formatMessage({ id: 'platformNoticesPage.title' })} data-testid="platformNoticesPage.table">
                <TableHeader>
                    <Column><FormattedMessage id='platformNoticesPage.table.header.start' /></Column>
                    <Column><FormattedMessage id='platformNoticesPage.table.header.end' /></Column>
                    <Column><FormattedMessage id='platformNoticesPage.table.header.event' /></Column>
                    <Column><FormattedMessage id='platformNoticesPage.table.header.status' /></Column>
                </TableHeader>
                <TableBody>
                    {noticesToShow.map(notice => (
                        <Row key={notice.id}>
                            <Cell>{formatDate(notice.start, '', 'DD MMM YYYY, HH:mm')}</Cell>
                            <Cell>{formatDate(notice.end, '', 'DD MMM YYYY, HH:mm')}</Cell>
                            <Cell>{notice.event}</Cell>
                            <Cell><PlatformNoticeStatus status={notice.status} /></Cell>
                        </Row>
                    ))}
                </TableBody>
            </Table>
        </Page>
    );
};

export default PlatformNoticesPage;
